import { projectColorInk, projectSymbol, validProjectColor } from "@/lib/projectIcons";

export type ProjectAppearance = { key?: string; icon?: string | null; color?: string | null };

/** Shared project identity in creation, navigation, headers and settings. */
export function ProjectIcon({ project, size = 18, tile = false }: { project: ProjectAppearance; size?: number; tile?: boolean }) {
  const symbol = projectSymbol(project.icon);
  const initials = !project.icon || !symbol;
  const Glyph = !initials ? symbol.glyph : undefined;
  const color = project.color && validProjectColor(project.color) ? project.color : "var(--accent)";
  return <span aria-hidden="true" data-project-icon={initials ? "initials" : symbol.value ?? "initials"}
    className="inline-flex shrink-0 items-center justify-center align-middle font-semibold leading-none"
    style={{ width: size, height: size, borderRadius: tile ? Math.round(size * .24) : 4,
      color: initials ? projectColorInk(project.color ?? "") : color,
      background: initials ? color : tile ? `color-mix(in srgb, ${color} 13%, transparent)` : undefined,
      fontSize: size * .52 }}>
    {initials ? (project.key?.slice(0, size >= 32 ? 2 : 1) || "P") : Glyph && <Glyph size={Math.round(size * (tile ? .58 : .95))} strokeWidth={1.8} />}
  </span>;
}
